import React from 'react';
import { 
  Button, 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions,
  Typography
} from 'components/mui';
import { Archive as ArchiveIcon } from '@mui/icons-material';
import { bool, func, string } from 'prop-types';

/**
 * @component ArchiveConfirmationDialog
 * @param {Object} props
 * @param {boolean} props.open - Whether the dialog is open
 * @param {function} props.onClose - Function to close the dialog
 * @param {function} props.onConfirm - Function to confirm the archive action
 * @param {string} props.contactName - Name of the contact being archived (optional)
 * @param {boolean} props.loading - Whether the archive operation is in progress
 * @returns {JSX.Element}
 */
function ArchiveConfirmationDialog({ 
  open, 
  onClose, 
  onConfirm, 
  contactName = 'this contact',
  loading = false 
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Confirm Archive</DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          Are you sure you want to archive {contactName}?
        </Typography>
        <Typography 
          variant="body2" 
          sx={{ 
            color: 'grey.500', 
            fontStyle: 'italic',
            marginTop: 1
          }}
        >
          This will hide the contact from the main list but preserve all data.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={onClose} 
          color="primary"
          disabled={loading}
        >
          Cancel
        </Button>
        <Button 
          onClick={onConfirm} 
          color="warning" 
          variant="contained"
          startIcon={<ArchiveIcon />}
          disabled={loading}
        >
          {loading ? 'Archiving...' : 'Archive'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ArchiveConfirmationDialog.propTypes = {
  open: bool.isRequired,
  onClose: func.isRequired,
  onConfirm: func.isRequired,
  contactName: string,
  loading: bool,
};

export default ArchiveConfirmationDialog;
